import React, { Component } from 'react';
import {Alert} from 'reactstrap';
import Logic from '../../Logic';
import FontAwesome from 'react-fontawesome';

class Step10 extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount(){
        setTimeout(()=>{
            //Redirect the user to candidates page when done
            if(this.props.init.user || this.props.init.admin){
                if(window.confirm('סיימת למלא את טופסי הבקשה בהצלחה. פרטי המועמד יועברו למשרד הביטחון רק לאחר לחיצה על כפתור "אשר מועמד" במסך רשימת המועמדים. האם תרצה לחזור למסך רשימת המועמדים כעת?')){
                    let logic = new Logic();
                    // let baseURL = logic.getBaseRedirectUrl();
                    // window.location = baseURL + '#/mycandidates';
                    this.props.history.push({
                        pathname: '/mycandidates',
                        state:{isToRefresh:true}
                    })
                }
            }else if(this.props.init.candidate){
                if(window.confirm('סיימת למלא את טופסי הבקשה בהצלחה. האם תרצה לסגור את החלון?')){
                    window.close();
                }
            }
        }, 2 * 1000)
    }

    render() {
        return (
            <div>
            { this.props.init.candidate ? 
            <div>
                <Alert color="primary"><FontAwesome name="check" style={{color:'white', fontSize:'140%'}}/> פרטיך נקלטו במערכת, והועברו לבדיקת משרד הביטחון.</Alert>
            </div> :
            <div>
                <Alert color="primary"><FontAwesome name="check" style={{color:'white', fontSize:'140%'}}/> טופסי המועמד נשמרו במערכת. תודה.</Alert>
            </div>
            }
        </div>
        );
      }
}

export default Step10;